import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { getFeeByUserIdApi, getFeeRenewalsApi } from '../../Api/Fee';
import { useNavigate } from "react-router-dom";
import { getFeeRequestApi } from '../../Api/Registration';

interface CourseType {
    id: string;
    name: string;
    durationType: string;
    fees: number;
}

interface Course {
    id: string;
    name: string;
}

interface Registration {
    id: string;
    courseOfferingId: string;
    courseType: CourseType;
    course: Course;
    userId: string;
    userName: string;
    duration: number;
    timeZone: string;
    timeRange: string;
    status: string;
    fee: number;
    feeFor: string;
    updatedBy: string;
    updatedOn: string;
}

interface SelectedFee {
    id: string;
    amount: number;
    feeFor: string;
    userId: string
    userName: string;
    courseName: string;
    courseType: string;
    courseOfferingId: string;
}

interface Props {
    url: string;
    isDarkMode: boolean;
}

type Fees = {
    id: string;
    amount: number;
    userId: string;
    courseOfferingId: string;
    userName: string;
    paid: boolean;
    paidOn?: string | null;
    paidTill?: string | null;
    type: string;
    courseName: string;
    courseType: string;
    durationType: string;
    typeId: string;
    donationDetailId?: string | null;
    feeFor: string;
    updatedOn: string;
};

export function Fee({ url, isDarkMode }: Props) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(true);
    const [selectedFee, setSelectedFee] = useState<SelectedFee[]>([]);
    const [Fees, setFees] = useState<Registration[]>([]);
    const [FeeRenawal, setFeeRenawal] = useState<Fees[]>([]);

    const handleApiCallClick = async () => {
        try {
            setLoading(true);
            const PendingFee = await getFeeRequestApi(url) as Registration[];
            const feeRenawal = await getFeeRenewalsApi(url);
            console.log("feeRenawal ", PendingFee);
            setFees(PendingFee);
            setFeeRenawal(feeRenawal);
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleApiCallClick();
    }, []);

    const handleCheckboxChange = (item: any) => {
        setSelectedFee((prev) => {
            const id = item.id; // id for Fees, typeId for FeeRenawal
            const exists = prev.some((fee) => fee.id === id);
            if (exists) {
                return prev.filter((fee) => fee.id !== id);
            } else {
                return [
                    ...prev,
                    {
                        id: item.id,
                        amount: item.fee ?? item.amount,
                        feeFor: item.feeFor,
                        userId: item.userId,
                        userName: item.userName,
                        courseName: item.course?.name ?? item.courseName,
                        courseType: item.courseType?.name ?? item.courseType,
                        courseOfferingId: item.courseOfferingId,
                    },
                ];
            }
        });
    };

    const handlePayNowClick = () => {
        navigate("/donate", { state: { selectedFee } });
    }

    return (   
        <div className={`py-14 ${isDarkMode ? 'bg-globalBg text-white' : 'bg-white text-black'}`}>
            <div className={`lg:mx-[320px] md:mx-0 rounded-lg shadow-md overflow-hidden 
                ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}>
                <div className={`p-6 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                    <h2 className="text-2xl font-bold text-blue-600">Fee Payment</h2>
                </div>
                <div className="relative p-6">
                    <div className="overflow-x-auto">
                        <table className="min-w-full table-auto border-collapse ">
                            <thead>
                                <tr className={`${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-50 text-black'}`}>
                                    <th className="w-[50px] px-5 py-3"></th>
                                    <th className="px-5 py-3 text-left text-sm font-medium  tracking-wider">Course Name</th>
                                    <th className="px-5 py-3 text-left text-sm font-medium  tracking-wider">User Name</th>
                                    <th className="px-5 py-3 text-left text-sm font-medium  tracking-wider">Course Type</th>
                                    <th className="px-5 py-3 text-left text-sm font-medium  tracking-wider">Billing Frequency</th>
                                    <th className="px-5 py-3 text-right text-sm font-medium  tracking-wider">Fee Amount</th>
                                    <th className="px-5 py-3 text-right text-sm font-medium  tracking-wider">Type</th>
                                </tr>
                            </thead>
                            <tbody className={isDarkMode ? 'divide-y divide-gray-700' : 'divide-y divide-gray-200'}>
                                {Fees.length === 0 && FeeRenawal.length === 0 ? (
                                    <tr>
                                        <td colSpan={7} className="px-5 py-8 text-center text-gray-500">
                                            No pending fees found.
                                        </td>
                                    </tr>
                                ) : (
                                    <>
                                        {Fees.map((item) => (
                                            <tr key={item.id}>
                                                <td className="px-5 py-4 whitespace-nowrap">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedFee.some((fee) => fee.id === item.id)}
                                                        onChange={() => handleCheckboxChange(item)}
                                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                    />
                                                </td>
                                                <td className="px-5 py-4 whitespace-nowrap font-medium">{item.course.name}</td>
                                                <td className="px-5 py-4 whitespace-nowrap">{item.userName}</td>
                                                <td className="px-5 py-4 whitespace-nowrap">{item.courseType.name}</td>
                                                <td className="px-5 py-4 whitespace-nowrap">{item.courseType.durationType}</td>
                                                <td className="px-5 py-4 whitespace-nowrap text-right">₹{item.fee.toLocaleString("en-IN")}</td>
                                                <td className="px-5 py-4 whitespace-nowrap">Registration</td>
                                            </tr>
                                        ))}
                                    </>
                                )}

                                {FeeRenawal.map((item) => (
                                    <tr key={item.id}>
                                        <td className="px-5 py-4 whitespace-nowrap">
                                            <input
                                                type="checkbox"
                                                checked={selectedFee.some((fee) => fee.id === (item.id))}
                                                onChange={() => handleCheckboxChange(item)}
                                                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                            />
                                        </td>
                                        <td className="px-5 py-4 whitespace-nowrap font-medium">{item.userName}</td>
                                        <td className="px-5 py-4 whitespace-nowrap">{item.userName}</td>
                                        <td className="px-5 py-4 whitespace-nowrap">{item.courseType}</td>
                                        <td className="px-5 py-4 whitespace-nowrap">{item.durationType}</td>
                                        <td className="px-5 py-4 whitespace-nowrap text-right">₹{item.amount.toLocaleString("en-IN")}</td>
                                        <td className="px-5 py-4 whitespace-nowrap">Renawal</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {loading && (
                        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
                            <div className="w-12 h-12 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
                        </div>
                    )}
                </div>
                <div className={`px-6 py-4 border-t flex justify-between items-center 
                    ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
                    {/* <div className="text-lg font-semibold">Total: ₹{totalFee.toLocaleString("en-IN")}</div> */}
                    <button
                        disabled={selectedFee.length === 0}
                        className={`px-4 py-2 rounded-md text-white ${selectedFee.length === 0
                            ? 'bg-gray-400 cursor-not-allowed'
                            : isDarkMode
                                ? 'bg-blue-600 hover:bg-blue-700'
                                : 'bg-blue-600 hover:bg-blue-700'
                            }`}
                        onClick={handlePayNowClick}
                    >
                        Pay Now
                    </button>
                </div>
            </div>
        </div>
    );
};
